import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";

export default class AnnotationUploader {

    constructor(apiHost) {
        this.apiHost = apiHost;
    }

    uploadAnnotationToS3 = async (annotationData) => {
        try {
            const path = `/default`;
            let response = await ApiCallerClient.callApi({
                "endpoint": {
                    "hostName": this.apiHost,
                    "httpMethod": ApiMethod.POST,
                    "path": path
                },
                "body": JSON.stringify({
                    "purpose": "ANNOTATION_UPLOAD",
                    "annotationData": annotationData
                })
            });
            return response?.body ? JSON.parse(response.body) : {};
        } catch (error) {
            console.error('Error uploading annotation for deletion:', error);
            throw error;
        }
    }
}